export const ERR_NO_ORDER_ID = "Missing POS current order ID";
export const ERR_NO_REFERENCE_NUMBER =
    "Missing POS current order reference number";
export const NO_DISCOUNTS_CART_EMPTY =
    "Discount(s) must be removed when the cart is empty.";
export const PENDING_ORDER_INVALID_ENTITIES =
    "Pending order contains entities not in store / global menu used by POS.";
export const NO_STORE_ID = "Missing POS store ID";
